import { isEmpty } from 'lodash';

/** Recursively checks an object to see if all nested values are `isEmpty`.
 * Uses `any` type as that's what `isEmpty` uses
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDeepEmpty = (obj: any): obj is null | undefined => {
  if (isEmpty(obj)) return true;
  if (typeof obj !== 'object') return isEmpty(obj);
  return Object.keys(obj).every((key) => {
    const value = obj[key];
    if (typeof value === 'object' && value !== null) {
      return isDeepEmpty(value);
    }
    return isEmpty(value);
  });
};
